import React, { useContext, useState } from "react";
import { TranslationContext } from "../../contexts/TranslationContext";
import { LoginContext } from "./LoginContext";


export function CreateUserForm(props: {
    onUserCreated: () => void
}) {
    const lc = useContext(LoginContext);
    const tc = useContext(TranslationContext);

    const [isWorking, setIsWorking] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+45");
    const [email, setEmail] = useState("");

    const canCreate = !!username
        && !!password
        && phoneNumber.length > 3
        && !isWorking
        ;


    async function createUser(evt: React.FormEvent) {
        evt.preventDefault();
        if (!canCreate)
            return;
        let success = false;
        try {
            setIsWorking(true);
            success = await lc.loginService.createCustomer(username,
                password,
                name,
                phoneNumber,
                email
            );
            if (success)
                props.onUserCreated();
        }
        finally {
            if (!success)
                setIsWorking(false);
        }

    }

    const tcUsername = tc.translator("login modal username", "Brugernavn");
    const tcPassword = tc.translator("login modal password", "Password");
    const tcName = tc.translator("login modal name", "Navn");
    const tcPhone = tc.translator("login modal phoneNumber", "Telefonnummer");
    const tcEmail = tc.translator("login modal email", "E-mail");

    return (
        <div className="create-user-form">
            <form onSubmit={createUser}>
                <h3>
                    {tc.translator("create user header", "Opret ny bruger")}
                </h3>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <label htmlFor="create-user-form-username">
                                    {tcUsername}
                                </label>
                            </td>
                            <td>
                                <input type="text"
                                    className="form-control"
                                    placeholder={tcUsername}
                                    title={tcUsername}
                                    autoComplete="username"
                                    name="username"
                                    id="create-user-form-username"
                                    required
                                    value={username}
                                    onChange={evt => setUsername(evt.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="login-form-password">
                                    {tcPassword}
                                </label>
                            </td>
                            <td>
                                <input type="password"
                                    className="form-control"
                                    id="login-form-password"
                                    placeholder={tcPassword}
                                    title={tcPassword}
                                    autoComplete="new-password"
                                    required
                                    value={password}
                                    onChange={evt => setPassword(evt.target.value)}
                                    name="password" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="login-form-name">
                                    {tcName}
                                </label>
                            </td>
                            <td>
                                <input type="text"
                                    className="form-control"
                                    placeholder={tcName}
                                    title={tcName}
                                    autoComplete="name"
                                    name="username"
                                    id="login-form-name"
                                    required
                                    value={name}
                                    onChange={evt => setName(evt.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="login-form-phone">
                                    {tcPhone}
                                </label>
                            </td>
                            <td>
                                <input type="text"
                                    className="form-control"
                                    placeholder={tcPhone}
                                    autoComplete="tel"
                                    name="phone"
                                    title={tcPhone}
                                    id="login-form-phone"
                                    required
                                    value={phoneNumber}
                                    onChange={evt => setPhoneNumber(evt.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="login-form-email">
                                    {tcEmail}
                                </label>
                            </td>
                            <td>
                                <input type="text"
                                    className="form-control"
                                    placeholder={tcEmail}
                                    autoComplete="email"
                                    name="email"
                                    title={tcEmail}
                                    id="login-form-email"
                                    value={email}
                                    onChange={evt => setEmail(evt.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div style={{ marginTop: "25px" }} >
                                    <button type="submit"
                                        className="btn btn-block btn-primary"
                                        disabled={!canCreate} >
                                        {tc.translator("create-user modal button", "Opret bruger")}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    );
}
